import Image from 'next/image';
import Link from 'next/link';
import { getEdgeUrl } from '@/lib/getEdgeUrl';

const BoxingDayTheme = ({ closeMenu }: { closeMenu: () => void }) => (
  <div className="px-5 py-2.5">
    <Link href="/collections/hot-deals" onClick={closeMenu} className="group">
      <div className="relative flex h-[70px] items-center justify-between gap-3 rounded-lg bg-black px-3">
        {/* Starry Night Overlay */}
        <div className="absolute inset-0">
          <Image
            src={getEdgeUrl('images/hot-deals/menu/starry-bg-deals.png')}
            alt="Left Section"
            loading="eager"
            height={800}
            width={800}
            className="h-full w-full rounded-lg object-cover object-center"
            priority
          />
        </div>
        <div className="absolute left-0 top-0 z-0 h-full w-full rounded-l-lg bg-cover bg-center opacity-90">
          <Image
            src={getEdgeUrl('images/hot-deals/menu/boxing-2025.png')}
            alt="Hot Deals"
            height={200}
            width={400}
            className="h-full w-auto rounded-l-lg"
            quality={100}
          />
        </div>
        <h3 className="z-10 ml-2 text-sm font-bold text-white">
          Boxing Day Deals
        </h3>
        <div className="z-10 shrink-0 rounded-full bg-red px-4 py-2 text-xs font-semibold text-white group-hover:underline">
          Shop Now
        </div>
      </div>
    </Link>
  </div>
);

export default BoxingDayTheme;
